import { BatchedOperationError } from '@/user_files/batching/errors'
import { MoveSelectionRequest, MoveSelectionResponse } from './schemas'

export class BatchedMoveError extends BatchedOperationError<MoveSelectionRequest, MoveSelectionResponse> {
  constructor(params: { message: string; partialResult: MoveSelectionResponse; failedBatch: MoveSelectionRequest; cause?: unknown }) {
    super(params)
    this.name = 'BatchedMoveError'
  }
}
